import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.nav`
  height: 3rem;
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  width: 100%;
`;

const Toolbar = styled.div<{ projectColor: string }>`
  color: ${s => s.projectColor};
  display: flex;
  height: 100%;
  align-items: center;
  padding-left: 0.75rem;
`;

const ToolbarItem = styled.div`
  flex: 1;
  height: 100%;
`;

const List = styled.ul`
  display: flex;
  justify-content: flex-end;
  font-size: 0.75rem;
  font-weight: 700;
  height: 100%;
  margin-bottom: 0;
  margin-top: 0;
`;

const ToolBarTitle = styled.p`
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  margin-left: 0.5rem;
`;

const ProjectName = styled.span`
  color: #566072;
  border-left: 1px solid #e4e4e4;
  margin-left: 1rem;
  font-weight: normal;
  font-size: 20px;
  padding-left: 0.8rem;
`;

interface Props {
  projectType: string;
  projectId: number;
  projectColor: string;
  projectName?: string;
  assetIcon: ReactNode;
  children: ReactNode;
}

export const ViewerToolbar = (props: Props) => {
  return (
    <Wrapper>
      <Toolbar projectColor={props.projectColor}>
        {props.assetIcon}
        <ToolBarTitle>
          {props.projectType}
          {props.projectName && <ProjectName>{props.projectName}</ProjectName>}
        </ToolBarTitle>
        <ToolbarItem>
          <List>{props.children}</List>
        </ToolbarItem>
      </Toolbar>
    </Wrapper>
  );
};

export default ViewerToolbar;
